import React, { useState, useEffect } from 'react';
import api from '../services/api';
import useWindowWidth from '../hooks/useWindowWidth';
import { swalSuccess, swalError } from '../utils/alert';
import './ExpenseForm.css';
import './RevenueDesktop.css';

function CategoryForm({ category, onSuccess }) {
  const [formData, setFormData] = useState(
    category || {
      name: '',
      type: 'Receita',
      parent_id: '',
      color: '#000000',
      icon: '',
      status: 'Ativa',
    }
  );
  const [parentCategories, setParentCategories] = useState([]);
  const width = useWindowWidth();
  const isMobile = width < 768;

  const typeOptions = [
    { id: 'Receita', label: 'Receita', icon: '📈' },
    { id: 'Despesa', label: 'Despesa', icon: '📉' },
  ];

  const statusOptions = [
    { id: 'Ativa', label: 'Ativa', color: 'success' },
    { id: 'Inativa', label: 'Inativa', color: 'danger' },
  ];

  useEffect(() => {
    api.get('/categories')
      .then(response => {
        setParentCategories(response.data);
      })
      .catch(error => {
        console.error('Houve um erro ao buscar as categorias pai!', error);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleTypeClick = (type) => {
    setFormData({ ...formData, type });
  };

  const handleStatusClick = (status) => {
    setFormData({ ...formData, status });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const method = category ? 'put' : 'post';
    const url = category
      ? `/categories/${category.id}`
      : '/categories';

    api[method](url, formData)
      .then(() => {
        swalSuccess('Categoria salva com sucesso!');
        onSuccess();
      })
      .catch(error => {
        console.error('Houve um erro ao salvar a categoria!', error);
        swalError('Erro ao salvar categoria.');
      });
  };

  // ════════════════════════════════════
  // MOBILE FORM
  // ════════════════════════════════════
  const renderMobileForm = () => (
    <form onSubmit={handleSubmit} className="expense-form-mobile" autoComplete="off">

      {/* Tipo */}
      <div className="form-section">
        <label className="section-label">Tipo</label>
        <div className="payment-methods-grid">
          {typeOptions.map(option => (
            <button
              type="button"
              key={option.id}
              className={`payment-method-btn ${formData.type === option.id ? 'active' : ''}`}
              onClick={() => handleTypeClick(option.id)}
            >
              <span className="payment-icon">{option.icon}</span>
              <span className="payment-label">{option.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Nome */}
      <div className="form-section">
        <label className="section-label">Nome</label>
        <input
          type="text"
          className="form-control form-control-lg"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Nome da categoria"
          required
        />
      </div>

      {/* Categoria Pai + Ícone */}
      <div className="form-section">
        <div className="row g-2">
          <div className="col-8">
            <label className="section-label">Categoria Pai (Opcional)</label>
            <select className="form-select" name="parent_id" value={formData.parent_id} onChange={handleChange}>
              <option value="">Nenhum</option>
              {parentCategories.map(cat => (
                <option key={cat.id} value={cat.id}>{cat.name}</option>
              ))}
            </select>
          </div>
          <div className="col-4">
            <label className="section-label">Ícone</label>
            <input
              type="text"
              className="form-control"
              name="icon"
              value={formData.icon}
              onChange={handleChange}
              placeholder="ex: 🏠"
            />
          </div>
        </div>
      </div>

      {/* Cor */}
      <div className="form-section">
        <label className="section-label">Cor</label>
        <input
          type="color"
          className="form-control form-control-color w-100"
          name="color"
          value={formData.color}
          onChange={handleChange}
          required
          style={{ height: '48px' }}
        />
      </div>

      {/* Status */}
      <div className="form-section">
        <label className="section-label">Status</label>
        <div className="status-buttons">
          {statusOptions.map(s => (
            <button
              type="button"
              key={s.id}
              className={`status-btn ${s.color} ${formData.status === s.id ? 'active' : ''}`}
              onClick={() => handleStatusClick(s.id)}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mobile-form-footer">
        <button type="submit" className="btn btn-primary btn-lg w-100">
          Salvar Categoria
        </button>
      </div>
    </form>
  );

  // ════════════════════════════════════
  // DESKTOP FORM
  // ════════════════════════════════════
  const renderDesktopForm = () => (
    <form onSubmit={handleSubmit} className="rv-form-desktop">

      {/* Tipo */}
      <div className="rv-form-field-full">
        <label className="rv-form-label">Tipo</label>
        <div className="rv-payment-grid">
          {typeOptions.map(option => (
            <button
              type="button"
              key={option.id}
              className={`rv-payment-btn ${formData.type === option.id ? 'active' : ''}`}
              onClick={() => handleTypeClick(option.id)}
            >
              <span className="rv-pay-icon">{option.icon}</span>
              <span>{option.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Nome + Categoria Pai */}
      <div className="rv-form-grid-2">
        <div className="rv-form-field">
          <label className="rv-form-label" htmlFor="name">Nome</label>
          <input type="text" className="rv-form-input" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Nome da categoria" required />
        </div>
        <div className="rv-form-field">
          <label className="rv-form-label" htmlFor="parent_id">Categoria Pai (Opcional)</label>
          <select className="rv-form-select" id="parent_id" name="parent_id" value={formData.parent_id} onChange={handleChange}>
            <option value="">Nenhum</option>
            {parentCategories.map(cat => (
              <option key={cat.id} value={cat.id}>{cat.name}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Ícone + Cor */}
      <div className="rv-form-grid-2">
        <div className="rv-form-field">
          <label className="rv-form-label" htmlFor="icon">Ícone (Opcional)</label>
          <input type="text" className="rv-form-input" id="icon" name="icon" value={formData.icon} onChange={handleChange} placeholder="ex: 🏠" />
        </div>
        <div className="rv-form-field">
          <label className="rv-form-label" htmlFor="color">Cor</label>
          <input type="color" className="rv-form-input" id="color" name="color" value={formData.color} onChange={handleChange} required style={{ height: '40px', padding: '0.25rem' }} />
        </div>
      </div>

      {/* Status */}
      <div className="rv-form-field-full">
        <label className="rv-form-label">Status</label>
        <div className="rv-status-group">
          {statusOptions.map(s => (
            <button
              type="button"
              key={s.id}
              className={`rv-status-toggle ${formData.status === s.id ? `active-${s.color}` : ''}`}
              onClick={() => handleStatusClick(s.id)}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>

      <div className="rv-form-footer">
        <button type="submit" className="rv-btn-submit">Salvar Categoria</button>
      </div>
    </form>
  );

  return isMobile ? renderMobileForm() : renderDesktopForm();
}

export default CategoryForm;
